import React from 'react'
import { Loader } from '@usap/uicomponents'
import RMAForm from './RMAForm'
import ReturnItemContextProvider from '../../../contexts/ReturnItemContextProvider'
import SelectedItemsContextProvider from '../../../contexts/SelectedItemsContextProvider'
import { RMAContainer } from './style/RMA.css'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

const RMA = ({
  isDesktop,
  isAmp,
  isBot,
  Link,
  loading,
  setLoading,
  onSubmit,
  onCancelReturn,
  orderDetails,
  handleReason,
  appSteps,
  setAppSteps,
  GTM,
  imgSteps,
  setImgSteps,
  docSteps,
  setDocSteps,
  customerOrder,
  setCustomerOrder,
  fileUpload,
  setFileUpload,
  formFile,
  setFormFile,
  tempStep,
  setTempStep,
  reqElem,
  setReqElem,
  returnQuantity,
  setReturnQuantity,
  mechanicDiagnosis,
  tokenCustomerId,
  showTabs,
  setShowTabs,
  formFileMain,
  setFormFileMain,
  creditStatus,
  returnRequestStatus,
  returnReasonUtils,
  siteKey,
  OpenChatHandler,
}) => {
  const isWmoEnabled = useWmoEnabled()

  return (
  <ReturnItemContextProvider>
    <SelectedItemsContextProvider>
      <RMAContainer isWmoEnabled={isWmoEnabled}>
        {loading && <Loader />}
        <RMAForm
          isDesktop={isDesktop}
          isAmp={isAmp}
          isBot={isBot}
          Link={Link}
          loading={loading}
          setLoading={setLoading}
          onSubmit={onSubmit}
          onCancelReturn={onCancelReturn}
          orderDetails={orderDetails}
          handleReason={handleReason}
          GTM={GTM}
          appSteps={appSteps}
          setAppSteps={setAppSteps}
          imgSteps={imgSteps}
          setImgSteps={setImgSteps}
          customerOrder={customerOrder}
          setCustomerOrder={setCustomerOrder}
          fileUpload={fileUpload}
          setFileUpload={setFileUpload}
          siteKey={siteKey}
          formFile={formFile}
          setFormFile={setFormFile}
          tempStep={tempStep}
          setTempStep={setTempStep}
          reqElem={reqElem}
          setReqElem={setReqElem}
          returnQuantity={returnQuantity}
          setReturnQuantity={setReturnQuantity}
          tokenCustomerId={tokenCustomerId}
          showTabs={showTabs}
          setShowTabs={setShowTabs}
          formFileMain={formFileMain}
          setFormFileMain={setFormFileMain}
          docSteps={docSteps}
          setDocSteps={setDocSteps}
          mechanicDiagnosis={mechanicDiagnosis}
          creditStatus={creditStatus}
          returnRequestStatus={returnRequestStatus}
          returnReasonUtils={returnReasonUtils}
          OpenChatHandler={OpenChatHandler}
        />
      </RMAContainer>
    </SelectedItemsContextProvider>
  </ReturnItemContextProvider>)
}

export default RMA
